import type { SvgComponent } from '@/types/SvgComponent';

export const ChatCircleIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M3.125 15.625V5A1.875 1.875 0 0 1 5 3.125H15A1.875 1.875 0 0 1 16.875 5V11.875A1.875 1.875 0 0 1 15 13.75H6.25L3.125 15.625Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
